import { render, staticRenderFns } from "./HomeNoticeCard.vue?vue&type=template&id=37196cd2&scoped=true&"
import script from "./HomeNoticeCard.vue?vue&type=script&lang=js&"
export * from "./HomeNoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeNoticeCard.vue?vue&type=style&index=0&id=37196cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37196cd2",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
